import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import MatrixInputDialogChips from "../MatrixInputChips";
import CustomButton from "../../../../../../../../components/Button/CustomButton";

export interface MatrixInputDialogProps extends DialogProps {
  testSeriesName: string;
  cutHorizPadding?: boolean;
  onClose: () => void;
  handleOpenConfiguration: () => void;
}

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    margin: "2rem",
    marginTop: "0",
    overflowX: "hidden",
  },
  cutHorizPadding: {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  icon: {
    cursor: "pointer",
    position: "absolute",
    right: "2rem",
    top: "2rem",
    zIndex: 100,
  },
});

const MatrixInputDialog: React.FC<MatrixInputDialogProps> = (props) => {
  const {
    children,
    className,
    testSeriesName,
    cutHorizPadding,
    fullScreen,
    fullWidth,
    maxWidth,
    onClose,
    open,
    handleOpenConfiguration,
    ...restProps
  } = props;
  const classes = useStyles(props);

  return (
    <Dialog
      className={className}
      style={fullScreen ? { margin: 32 } : undefined}
      fullScreen={fullScreen}
      open={open}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      onClose={onClose}
      {...restProps}
    >
      <CloseIcon
        className={[classes.icon, className].join(" ")}
        onClick={() => {
          onClose();
        }}
      />
      <Box marginTop="2rem" marginLeft="2rem" marginRight="2rem">
        <h2>{`${testSeriesName} - Input Matrix`}</h2>
        <MatrixInputDialogChips />
        <Box marginBottom={1}>
          <CustomButton
            text="Configure Matrix Input"
            onClick={() => {
              handleOpenConfiguration();
            }}
          />
          <p>Matrix elements with crossed out values show voided repetitions.</p>
        </Box>
      </Box>
      <div className={[classes.container, cutHorizPadding && classes.cutHorizPadding].join(" ")}>{children}</div>
    </Dialog>
  );
};

export default MatrixInputDialog;
